function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  msgList: [],
  unreadNum: 0
};

var setAllReaded = function setAllReaded(list) {
  return list.map(function (item) {
    return _objectSpread({}, item, {
      isClicked: true
    });
  });
};

var setMsgReaded = function setMsgReaded(list, id) {
  return list.map(function (item) {
    if (item.id === id) {
      return _objectSpread({}, item, {
        isClicked: true
      });
    }

    return item;
  });
};

var headerReducer = function headerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'header.fetchMsgListSuccess':
      {
        var unreadNum = action.msgList.reduce(function (num, item) {
          if (item.isClicked) {
            return num;
          }

          return num + 1;
        }, 0);
        return _objectSpread({}, state, {
          msgList: action.msgList,
          unreadNum: unreadNum
        });
      }

    case 'header.readAllSuccess':
      {
        var newList = setAllReaded(state.msgList);
        return _objectSpread({}, state, {
          msgList: newList,
          unreadNum: 0
        });
      }

    case 'header.readMsgSuccess':
      {
        var _newList = setMsgReaded(state.msgList, action.id);

        return _objectSpread({}, state, {
          msgList: _newList,
          unreadNum: state.unreadNum - 1
        });
      }

    default:
      return state;
  }
};

export default headerReducer;